// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-b875536a]{border-collapse:collapse}table[data-v-b875536a],td[data-v-b875536a],th[data-v-b875536a]{border:.5px solid #000}thead[data-v-b875536a]{display:table-row-group}tr td[data-v-b875536a]{page-break-inside:avoid}.no-border[data-v-b875536a]{border:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
